if (!customElements.get("table-of-contents")) {
  class TableOfContents extends HTMLElement {
    constructor() {
      super();

      
      this.h2Tags = this.closest('.article').querySelectorAll("h2");
      if (this.h2Tags.length < 1) return;

      this.toc = this.querySelector(".article-toc");
      this.setH2TagsId();
    }

    connectedCallback() {
      if ('IntersectionObserver' in window) {
        this.intersectionObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            // Page just loaded ... probably and a heading is in view
            if (entry.time < 2000 && entry.isIntersecting) {
              this.highlightActive(entry.target);
            } else if (entry.time < 2000) {
              // In this case page just loaded and no heading in view
              return;
            }
            // Scrolling up the page
            else if (!this.isIntersectingAtTop(entry) && !entry.isIntersecting) {
              // The first H2 tag just scrolled off the bottom of the viewport
              if (entry.target == this.h2Tags[0]) {
                if(this.activeH2) this.activeH2.classList.remove('active');
              }
              // Otherwise highlight the previous H2 tag
              else {
                let prevH2 = this.h2Tags[[...this.h2Tags].indexOf(entry.target) - 1];
                this.highlightActive(prevH2);
              }
            }
            // Scrolling down the page
            else if (entry.isIntersecting) {
              this.highlightActive(entry.target);
            }
          });
        }, { root: document, rootMargin: "0px", threshold: 1 });

        this.h2Tags.forEach((el) => {
          this.intersectionObserver.observe(el);
        })
      }
    }

    disconnectCallback() {
      this.intersectionObserver.disconnect();
    }
    
    setH2TagsId() {
      this.h2Tags.forEach((el) => {
        el.setAttribute("id", this.handleize(el.innerText));
      });
    }

    highlightActive(h2) {
      if(this.activeH2) this.activeH2.classList.remove('active');
      this.activeH2 = this.toc.querySelector(`a[href="#${h2.getAttribute("id")}"]`)
      this.activeH2.classList.add('active');
    }

    isIntersectingAtTop(entry) {
      return entry.rootBounds.bottom - entry.boundingClientRect.bottom > entry.rootBounds.bottom / 2 ? true : false
    }

    handleize(str) {
      return str
      .toLowerCase()
      .normalize('NFD')                                           // Normalize the string to NFD
      .replace(/[\u0300-\u036f]/g, '')                            // Remove diacritical marks                                              // Convert to lowercase
      .replace(/[\s°+]+/g, '-')                                   // Replace spaces and degree signs and plus signs with hyphens
      .replace(/[\u3000-\u303F]/g, '-')                           // Replace Japanese punctuation and ideographic spaces with hyphens
      .replace(/[\uFF00-\uFFEF\u2000-\u206F\u2E80-\u2EFF\u3000-\u303F\uFE30-\uFE4F\uFF01-\uFF5E]/g, '-') // Replace Chinese punctuation with hyphens
      .replace(/[^\w\u4e00-\u9fff\u3040-\u30ff\-]+/g, '')         // Remove non-word characters except Chinese, Japanese, and hyphens
      .replace(/\-\-+/g, '-')                                     // Replace multiple hyphens with a single hyphen
      .replace(/^-+|-+$/g, '')                                    // Trim hyphens from the start and end
      .normalize('NFKC');                                         // Normalize the string to NFKC (Japanese text)
    }
  }

  customElements.define("table-of-contents", TableOfContents);
}
